import { invitesQuery } from "domains/connect/containers/Network/queries";
import type { WarmableQuery } from "routing/warmQueries";

export const queries = (input: { orgId: string }): Array<WarmableQuery> => [invitesQuery(input)];
